import { TranslateHelper } from './../../../_helpers/translate-helper';
import { Component, Input } from '@angular/core';
import { Post } from '@interfaces/post';
import { RootService } from '@services/root.service';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { ClickDirective } from '../../directives/click.directive';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-post-card',
    templateUrl: './post-card.component.html',
    styleUrls: ['./post-card.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgClass, ExtendedModule, ClickDirective, RouterLink, NgFor, DatePipe, TranslateModule]
})
export class PostCardComponent {
    @Input() post: any;
    @Input() layout: 'grid-nl'|'grid-lg'|'list-nl'|'list-sm'|null = null;

    constructor(public root: RootService, public translateHelper: TranslateHelper) { }
}
